export default __webpack_public_path__ + "static/media/legend_borehole.6ca9965a.png";